import { defineStore } from 'pinia';
import {
  ref,
} from 'vue';

export const useSnapshotStore = defineStore('snapshots', () => {
  const snapshotFiles = ref([]);
  const parsingSnapshotFiles = ref(false);

  function $reset() {
    snapshotFiles.value = [];
    parsingSnapshotFiles.value = false;
  }

  return {
    snapshotFiles,
    parsingSnapshotFiles,
    $reset,
  };
});
